import * as React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const HeaderMenu = styled.nav`
  flex-grow: 2;
  background: #fff;
  position: relative;
  transition: opacity 0.35s ease-in-out;

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    z-index: -1;
  }

  li {
    margin: 0;
  }

  button,
  a {
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
    color: #222a3f;
  }

  @media (max-width: 1203px) {
    width: 0;
    min-height: calc(100vh - 56px);
    flex-direction: column;
    padding: 2rem 0;
    align-items: stretch;
    visibility: none;
    position: absolute;
    right: 0;
    top: 56px;
    transition: all 500ms;
    background: #fff;
    overflow: hidden;

    &[aria-hidden="false"] {
      width: 100vw;
      visibility: visible;
      padding: 2rem;
    }
  }

  @media (max-width: 306px) {
    top: 70px;
  }
`

const RightSide = styled.div`
  &[class] {
    margin-left: auto;
    margin-right: 0;

    @media (max-width: 365px) { 
      display: none;
    }
  }
`

const Search = styled.button`
  display: block;
  text-indent: -9999px;
  overflow: hidden;
  height: 22px;
  width: 22px;
  border: none;
  cursor: pointer;
  background-color: transparent;
  background-size: 22px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNDg3Ljk1IDQ4Ny45NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDg3Ljk1IDQ4Ny45NTsgZmlsbDogIzIyMmEzZjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGQ9Ik00ODEuOCw0NTNsLTE0MC0xNDAuMWMyNy42LTMzLjEsNDQuMi03NS40LDQ0LjItMTIxLjZDMzg2LDg1LjksMjk5LjUsMC4yLDE5My4xLDAuMlMwLDg2LDAsMTkxLjRzODYuNSwxOTEuMSwxOTIuOSwxOTEuMQ0KCQkJYzQ1LjIsMCw4Ni44LTE1LjUsMTE5LjgtNDEuNGwxNDAuNSwxNDAuNWM4LjIsOC4yLDIwLjQsOC4yLDI4LjYsMEM0OTAsNDczLjQsNDkwLDQ2MS4yLDQ4MS44LDQ1M3ogTTQxLDE5MS40DQoJCQljMC04Mi44LDY4LjItMTUwLjEsMTUxLjktMTUwLjFzMTUxLjksNjcuMywxNTEuOSwxNTAuMXMtNjguMiwxNTAuMS0xNTEuOSwxNTAuMVM0MSwyNzQuMSw0MSwxOTEuNHoiLz4NCgk8L2c+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg==");
`

const Explore = styled.li`
  position: relative;

  ul {
    position: absolute;
    top: 1.5em;
    right: 0;
    margin-right: 0;
    padding: 1rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    list-style-type: none;
    box-shadow: 9px 10px 13px -8px rgba(0,0,0,0.34);

    visibility: hidden;
    opacity: 0;
    z-index: -1;
    transition: all 300ms;

    @media (max-width: 1203px) {
      box-shadow: none;
      position: static;
    }

    &[aria-hidden="false"] {
      visibility: visible;
      opacity: 1;
      z-index: 1;
    }

    li,
    li:first-of-type {
      width: 335px;
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
      margin-right: 0 !important;
      margin-left: 0 !important;
      border-bottom: 1px solid #d6e1ef;
      margin-bottom: 10px;
      padding-bottom: 10px;

      &:last-of-type {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
      }

      @media (max-width: 500px) {
        width: 100%;
      }
    }
  }

  @media (max-width: 500px) {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3LjcxIDE0IiBjbGFzcz0iTWVnYU5hdk1lbnVJdGVtX21SaWdodF9fNDNmMzAzZmQiPjxwYXRoIGQ9Ik0uMjEgMS4yTDYgNyAuMjEgMTIuNzlhLjcuNyAwIDAwMCAxIC43LjcgMCAwMDEgMEw3LjUgNy41YS43LjcgMCAwMDAtMUwxLjIxLjIxYS43LjcgMCAwMC0xIDAgLjY5LjY5IDAgMDAwIC45OXoiLz48L3N2Zz4=);
    background-size: 14px 20px;
    background-position: right 5px;
    background-repeat: no-repeat;
    position: static;

    ul {
      width: 100vw;
      right: -100vw;
      top: 0;
      bottom: 0;
      position: absolute;
      margin: 0;
      padding: 2rem;
      padding-top: calc(3rem + 30px);

      &[aria-hidden="false"] {
        right: 0;
      }
    }
  }
`

const MenuUl = styled.ul`
  list-style-type: none;
  margin: 0 auto;
  max-width: 1400px;
  min-height: 66px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;

  @media (max-width: 1203px) {
    flex-direction: column;
    align-items: stretch;
    width: calc(100vw - 4rem);
    right: -100vw;

    nav[aria-expanded="true"] & {
      right: 0;
    }
  }
`

const ExploreButton = styled.button`
  transition: background-color 0.25s ease-in-out;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNjQgMzg0aDM4NHYtNDIuNjdINjR6bTAtMTA2LjY3aDM4NHYtNDIuNjZINjR6TTY0IDEyOHY0Mi42N2gzODRWMTI4eiIvPjwvc3ZnPg==);
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: left center;
  border: 3px solid transparent;
  height: 30px;
  padding: 0;
  padding-left: 40px;
  border-radius: 5px;
  cursor: pointer;

  span {
    pointer-events: none;
  }

  @media (min-width:1204px) and (max-width: 1260px) {
    span {
      border: 0;
      clip: rect(1px, 1px, 1px, 1px);
      clip-path: inset(50%);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
      word-wrap: normal !important;
    }
  }

  @media screen and (max-width: 500px) {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-right: 14px;
    background-image: none;
    padding-left: 0;

    &[aria-expanded="true"] {
      position: absolute;
      top: 2rem;
      left: 2rem;
      width: 100%;
      z-index: 2;
      padding-left: 30px;
      background-color: #fff;

      &:before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 1px;
        left: 0;
        height: 20px;
        width: 14px;
        transform: rotate(180deg);
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3LjcxIDE0IiBjbGFzcz0iTWVnYU5hdk1lbnVJdGVtX21SaWdodF9fNDNmMzAzZmQiPjxwYXRoIGQ9Ik0uMjEgMS4yTDYgNyAuMjEgMTIuNzlhLjcuNyAwIDAwMCAxIC43LjcgMCAwMDEgMEw3LjUgNy41YS43LjcgMCAwMDAtMUwxLjIxLjIxYS43LjcgMCAwMC0xIDAgLjY5LjY5IDAgMDAwIC45OXoiLz48L3N2Zz4=);
        background-repeat: no-repeat;
      }
    }
  }
`

const MenuToggle = styled.button`
  background: transparent;
  border: none;
  display: none;
  align-items: center;
  flex-direction: column;
  line-height: 1;
  font-size: 14px;
  margin: 0;

  span {
    pointer-events: none;
  }

  @media (max-width: 1203px) {
    display: flex;
  }
`

const ScreenReaderMobile = styled.span`
  @media (max-width: 500px) {
    border: 0;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    word-wrap: normal !important;
  }
`

const MenuIcon = styled.span`
  height: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  @media (max-width: 500px) {
    width: 30px;
  }

  span {
    height: 2px;
    width: 100%;
    background: #222a3f;
    transition: all 500ms;
  }

  [aria-expanded="true"] & {
    width: 30px;
    span {
      position: absolute;
      top: 10px;
    }
    span:first-of-type {
      transform: rotate(45deg);
    }

    span:nth-of-type(2) {
      opacity: 0;
    }

    span:last-of-type {
      transform: rotate(-45deg);
    }
  }
`;

const Mobile = styled.li`
  display: none;

  @media (max-width: 365px) {
    display: block;
  }
`

const toggleMenu = e => {
  e.preventDefault();

  const toggle = e.target || e.currentTarget;
  const menuID = toggle.getAttribute('aria-controls')
  const menu = document.getElementById(menuID);
  const focusEl = toggle.getAttribute( 'data-focus-element' );
  const firstMenuItem = focusEl ? document.getElementById( focusEl ) : menu.querySelector("a")
  const focusTrap = toggle.getAttribute( 'data-focus-trap' );
  const trapable = focusTrap ? document.getElementById( focusTrap ) : null;
  const expanded = "true" === toggle.getAttribute("aria-expanded");
  const dataSrc = toggle.getAttribute( 'data-src' );

  if (expanded) {
    // Hide the menu.
    toggle.setAttribute("aria-expanded", false)
    menu.setAttribute("aria-hidden", true)
    toggle.focus()

    if ( trapable ) {
      trapable.setAttribute( 'data-trapped', 'false' );
    }
  } else {
    // Show the menu.
    toggle.setAttribute("aria-expanded", true)
    menu.setAttribute("aria-hidden", false)
    firstMenuItem.focus()

    if ( trapable ) {
      trapable.setAttribute( 'data-trapped', 'true' );
    }
  }

  if ( dataSrc ) {
    const iframe = menu.querySelector('iframe');

    if (iframe && ! iframe.getAttribute('src')) {
      iframe.setAttribute('src', dataSrc);
    }
  }
}

const Menu = () => {
  return (
    <>
      <HeaderMenu id="header-menu" aria-label="Header Menu">
        <MenuUl>
          <li>
            <Link to="/surgery">Facial Plastic Surgery</Link>
          </li>
          <li>
            <Link to="/non-surgical-treatments">Non-Surgical</Link>
          </li>
          <li>
            <Link to="/under-eye-filler">Under-Eye Filler</Link>
          </li>
          <li>
            <Link to="/about">Meet Dr. Scheiner</Link>
          </li>
          <li>
            <Link to="/request-appointment">Request Appointment</Link>
          </li>
          <Mobile>
            <Link to="/search">Search the Site</Link>
          </Mobile>
          <Explore>
            <ExploreButton
              onClick={toggleMenu}
              id="header-menu-explore-toggle"
              aria-controls="header-menu-explore"
              aria-expanded="false"
            ><span>Explore</span></ExploreButton>
            <ul id="header-menu-explore" aria-hidden="true" aria-labelledby="header-menu-explore-toggle">
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              {/* <li>
                <Link to="/videos">Laser Surgery Videos</Link>
              </li> */}
              <li>
                <Link to="/10-things-you-need-to-know-about-festoons">10 things you should know about festoons</Link>
              </li>
              <li>
                <Link to="/how-to-get-rid-of-festoons-under-eyes">How to get rid of festoons</Link>
              </li>
              <li>
                <Link to="/malar-mounds-eyelid-festoons-is-there-a-natural-remedy">Natural remedy for festoons</Link>
              </li>
              <li>
                <Link to="/problems-with-fillers-under-the-eyes">Problems with fillers under the eyes</Link>
              </li>
              <li>
                <Link to="/dissolving-fillers-under-the-eyes">Dissolving fillers under the eyes</Link>
              </li>
              <li>
                <Link to="/festoons-after-fillers">Festoons after fillers</Link>
              </li>
              <li>
                <Link to="/what-are-and-how-can-we-fix-hollow-eyes">How to fix hollow eyes</Link>
              </li>
              <li>
                <Link to="/reviews">Patient Reviews</Link>
              </li>
            </ul>
          </Explore>
        </MenuUl>
      </HeaderMenu>
      <RightSide>
        <Search 
          id="search-toggle"
          aria-controls="search-container"
          aria-expanded="false"
          onClick={toggleMenu}
          aria-label="Toggle Search" 
          data-src="/search"
          data-focus-element="search-container"
        >Search</Search>
      </RightSide>
      <MenuToggle
        id="header-menu-toggle"
        aria-controls="header-menu"
        aria-expanded="false"
        onClick={toggleMenu}
        aria-label="Toggle Menu"
        data-focus-trap="page-header"
      >
        <MenuIcon>
          <span></span>
          <span></span>
          <span></span>
        </MenuIcon>
        <ScreenReaderMobile>Menu</ScreenReaderMobile>
      </MenuToggle>
    </>
  )
}

export default Menu
